import UniversalMaps from 'components/UniversalMaps';
import { useParams, useNavigate } from 'react-router-dom';

export default function ManualMaps() {
	const { qrcode, userId, imageId } = useParams();
	const navigate = useNavigate();

	const fallbackCallback = () => navigate('/qrcode');

	return <UniversalMaps mode="manual" qrcode={qrcode} userId={userId} imageId={imageId} cb={fallbackCallback} />;
}
